<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="workOrdersFiltered"
            class="elevation-0"
            :mobile-breakpoint="0"
            :loading="loading"
            :height="$vuetify.breakpoint.mdAndDown ? '65vh' : '65vh'"
            :footer-props="{
                itemsPerPageOptions: [15, 30, 100, -1],
                itemsPerPageText: 'Work Orders Per Page',
            }"
        >
            <template v-slot:top>
                <v-row
                    no-gutter
                    class="mt-0 mx-0 pt-4 pb-0 pb-4"
                    style="background-color: #eeeeee"
                >
                    <h1 class="mx-4">WORK ORDERS</h1>
                    <ValidationWorkOrders
                        :project-id="projectId || undefined"
                        :user="user"
                        :project-manager="project?.projectManager || undefined"
                    />
                </v-row>
            </template>
            <!--HEADERS-->
            <template v-slot:[`header.code`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="search"
                    dense
                />
            </template>
            <template v-slot:[`header.project`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="projectToFilter"
                    dense
                />
            </template>
            <!--ITEMS-->
            <template v-slot:[`item.createdBy`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">{{ item.createdBy.name }}</p>
                </div>
            </template>
            <template v-slot:[`item.approvedDate`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{
                            item.approvedDate
                                ? formatDate(
                                      item.approvedDate.seconds ||
                                          item.approvedDate._seconds,
                                      'L'
                                  )
                                : ''
                        }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.productionStart`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{
                            item.productionStart
                                ? formatDate(
                                      item.productionStart.seconds ||
                                          item.productionStart._seconds
                                  )
                                : item.scheduledOn
                                ? formatDate(
                                      item.scheduledOn.seconds ||
                                          item.scheduledOn._seconds
                                  ) || ''
                                : ''
                        }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.finishDate`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{
                            item.finishDate
                                ? formatDate(
                                      item.finishDate.seconds ||
                                          item.finishDate._seconds
                                  )
                                : item.finishedDate
                                ? formatDate(
                                      item.finishedDate.seconds ||
                                          item.finishedDate._seconds
                                  )
                                : ''
                        }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.project`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{ item.project.reference }} - {{ item.project.name }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.quality`]="{ item }">
                <div>
                    <v-tooltip right>
                        <template v-slot:activator="{ on }">
                            <v-col>
                                <v-btn
                                    x-small
                                    icon
                                    class="mr-1"
                                    color="white"
                                    style="background-color: #2b81d6;"
                                    v-on="on"
                                >
                                    <p class="my-0">
                                        {{ item.qualitySummary?.pending || 0 }}
                                    </p>
                                </v-btn>
                                <v-btn
                                    x-small
                                    icon
                                    class="mr-1"
                                    color="white"
                                    style="background-color: #2fbf56;"
                                    v-on="on"
                                >
                                    <p class="my-0">
                                        {{ item.qualitySummary?.released || 0 }}
                                    </p>
                                </v-btn>
                                <v-btn
                                    x-small
                                    icon
                                    class="mr-1"
                                    color="white"
                                    style="background-color: #ffa41d;"
                                    v-on="on"
                                >
                                    <p class="my-0">
                                        {{
                                            item.qualitySummary?.reprocess || 0
                                        }}
                                    </p>
                                </v-btn>
                                <v-btn
                                    x-small
                                    icon
                                    class="mr-1"
                                    color="white"
                                    style="background-color: #FF2610;"
                                    v-on="on"
                                >
                                    <p class="my-0">
                                        {{ item.qualitySummary?.rejected || 0 }}
                                    </p>
                                </v-btn>
                            </v-col>
                        </template>
                        <span>
                            Pending :
                            {{ item.qualitySummary?.pending || 0 }}
                            <br />
                            Released :
                            {{ item.qualitySummary?.released || 0 }} <br />
                            Reprocess :
                            {{ item.qualitySummary?.reprocess || 0 }} <br />
                            Rejected :
                            {{ item.qualitySummary?.rejected || 0 }} <br />
                        </span>
                    </v-tooltip>
                </div>
            </template>
            <template v-slot:[`item.packing`]="{ item }">
                <p>
                    {{ item.packingProgressText }}
                </p>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-menu rounded offset-y>
                    <template v-slot:activator="{ attrs, on }">
                        <v-btn
                            fab
                            v-bind="attrs"
                            v-on="on"
                            small
                            color="grey lighten-3"
                            depressed
                            class="mx-1"
                        >
                            <v-icon>mdi-dots-horizontal</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click.stop="openProcessWorkOrder(item)">
                            <v-list-item-icon>
                                <v-icon size="20">mdi-pencil</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Modify
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                            v-if="productionClosingPermission"
                            @click.stop="openProductionClosing(item)"
                        >
                            <v-list-item-icon>
                                <v-icon size="20"
                                    >mdi-package-variant-closed-check</v-icon
                                >
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Close Production
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </v-data-table>
        <!--PROCESS WORK ORDER-->
        <v-dialog
            v-model="processWorkOrder"
            :retain-focus="false"
            persistent
            fullscreen
        >
            <ProcessWorkOrder
                v-if="processWorkOrder"
                :order="selectedOrder"
                @close="closeProcessWorkOrder"
            />
        </v-dialog>
        <!-- close work order -->
        <v-dialog v-model="productionClosing" persistent max-width="400px">
            <v-card :loading="loading">
                <v-card-title class="text-h5">Close Work Order</v-card-title>
                <v-card-text>
                    Are you sure you want to close this work order?
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        color="secondary"
                        @click="closeProductionClosing"
                    >
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="closeWO"
                        text
                        color="primary"
                        :loading="loading"
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import { firestore } from '@/services/firebase'
import API from '@/services/api'
import { mapMutations, mapGetters, mapState, mapActions } from 'vuex'
import WOMethods from './WOMethods.js'

export default {
    name: 'Finished',
    props: {},
    components: {
        ProcessWorkOrder: () =>
            import('@/components/WorkOrders/ProcessWorkOrder.vue'),
        ValidationWorkOrders: () =>
            import('@/components/WorkOrders/ValidationWorkOrders.vue'),
    },
    data: () => ({
        selectedOrder: undefined,
        processWorkOrder: false,
        projectToFilter: undefined,
        projectToFilterDebounced: undefined,
        typeToFilter: undefined,
        typeToFilterDebounced: undefined,
        loading: false,
        workOrders: [],
        search: null,
        searchDebounced: null,
        user: {},
        users: {},
        projects: {},
        headers: [
            {
                text: 'ORDER',
                value: 'code',
                align: 'center',
                sortable: false,
                width: 120,
            },
            {
                text: 'CREATED BY',
                value: 'createdBy',
                align: 'center',
                sortable: false,
            },
            {
                text: 'PROJECT',
                value: 'project',
                align: 'center',
                sortable: false,
                width: 240,
            },
            {
                text: 'APPROVED DATE',
                value: 'approvedDate',
                align: 'center',
                sortable: true,
            },
            {
                text: 'PRODUCTION START',
                value: 'productionStart',
                align: 'center',
                sortable: true,
            },
            {
                text: 'FINISH DATE',
                value: 'finishDate',
                align: 'center',
                sortable: false,
            },
            {
                text: 'NOTES',
                value: 'notes',
                align: 'center',
                sortable: false,
            },
            {
                text: 'QUALITY',
                value: 'quality',
                align: 'center',
                sortable: false,
            },
            {
                text: 'PACKING',
                value: 'packing',
                align: 'center',
                sortable: false,
            },
            {
                text: 'ACTIONS',
                value: 'actions',
                align: 'center',
                sortable: false,
            },
        ],
        listener: undefined,
        companyId: JSON.parse(localStorage.getItem('company')),
        resourceId: undefined,
        settingProcesses: undefined,
        qualityProcess: {
            id: 'quality',
            name: 'Quality',
        },
        packingProcess: {
            id: 'packing',
            name: 'Packing',
        },
        productionClosingPermission: false,
        productionClosing: false,
        woMethods: new WOMethods(),
        deletedWorkOrdersIds: [],
    }),
    computed: {
        ...mapState(['notificationResource']),
        workOrdersFiltered() {
            this.openResource()
            let conditions = []
            if (this.searchDebounced) {
                conditions.push(this.filterOrder)
            }
            if (this.projectToFilterDebounced) {
                conditions.push(this.filterProject)
            }
            if (this.typeToFilterDebounced) {
                conditions.push(this.filterByType)
            }
            if (conditions.length > 0) {
                return this.workOrders.filter(order => {
                    return conditions.every(condition => {
                        return condition(order)
                    })
                })
            }
            this.sort()
            return this.workOrders
        },
    },
    watch: {
        notificationResource: function(resource) {
            if (resource) {
                this.resourceId = resource
                this.openResource()
                this.setNotificationResource(undefined)
            }
        },
        search: function(newValue) {
            this.debouncedSearch(newValue)
        },
        projectToFilter: function(newValue) {
            this.debouncedProjectFilter(newValue)
        },
        typeToFilter: function(newValue) {
            this.debouncedTypeFilter(newValue)
        },
    },
    created() {
        this.debouncedSearch = _.debounce(value => {
            this.searchDebounced = value
        }, 400)
        this.debouncedProjectFilter = _.debounce(value => {
            this.projectToFilterDebounced = value
        }, 400)
        this.debouncedTypeFilter = _.debounce(value => {
            this.typeToFilterDebounced = value
        }, 400)
    },
    async mounted() {
        try {
            this.loading = true
            this.resourceId = this.$route.query.resourceId

            const {
                user,
                projects,
                users,
                settings,
            } = await this.woMethods.bootstrapWoLookups({
                includeSettings: true,
            })
            this.user = user
            this.projects = projects
            this.users = users
            this.productionClosingPermission = user.permissions.includes(
                'closeWO'
            )
            this.settingProcesses = settings?.find(s => s.name == 'Processes')

            await this.getWOFromSDK()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    beforeDestroy() {
        if (this.listener) {
            this.listener()
            this.listener = null
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        ...mapActions(['setNotificationResource']),
        ...mapGetters(['getNotificationResource']),
        async loadAllActiveWorkOrders() {
            return await this.woMethods.loadAllActiveWorkOrders(
                this.companyId,
                ['finished'],
                false,
                ['finished', 'approved', 'closed']
            )
        },
        async getWOFromSDK() {
            try {
                this.loading = true

                let startDate = new Date()

                // Query with status filter only (readAllWO filtered in code)
                // Note: Finished only shows 'finished' status
                let query = firestore
                    .collection('companies')
                    .doc(this.companyId)
                    .collection('workOrders')
                    .where('status', 'in', ['finished', 'approved', 'closed'])
                    .where('updatedOn', '>=', startDate)

                // Load initial data from backup
                let initialData = await this.loadAllActiveWorkOrders()

                let data = await this.woMethods.mapInBatches(
                    initialData,
                    async wo => {
                        const formatted = await this.formatWorkOrder(wo)
                        if (formatted) {
                            this.attachListMetrics(formatted)
                        }
                        return formatted
                    }
                )

                this.workOrders = data

                this.listener = query.onSnapshot(async snapshot => {
                    const changes = Array.from(snapshot.docChanges())
                    const processedChanges = await Promise.all(
                        changes.map(async change => {
                            let wo = Object.assign(change.doc.data(), {
                                id: change.doc.id,
                            })
                            wo = await this.formatWorkOrder(wo)
                            return { change, wo }
                        })
                    )

                    // Process all changes after all have been formatted
                    processedChanges.forEach(({ change, wo }) => {
                        if (wo) {
                            this.attachListMetrics(wo)
                            if (
                                change.type === 'added' ||
                                change.type === 'modified'
                            ) {
                                const index = data.findIndex(w => w.id == wo.id)
                                if (index >= 0) {
                                    // Use $set to ensure Vue reactivity
                                    this.$set(data, index, wo)
                                } else {
                                    data.push(wo)
                                }
                            }
                            if (
                                change.type === 'removed' ||
                                wo.status !== 'finished'
                            ) {
                                const index = data.findIndex(w => w.id == wo.id)
                                if (index >= 0) {
                                    data.splice(index, 1)
                                }
                            }
                        }
                    })
                    // Force array update to ensure reactivity
                    this.workOrders = [...data]

                    // update selectedOrder if it's currently open
                    if (this.selectedOrder && this.selectedOrder.id) {
                        const updatedOrder = this.workOrders.find(
                            wo => wo.id == this.selectedOrder.id
                        )
                        if (updatedOrder) {
                            this.selectedOrder = _.cloneDeep(updatedOrder)
                        }
                    }
                })
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async formatWorkOrder(wo) {
            try {
                const workOrder = wo

                // Filter by status (already in query, but double check)
                // Finished only shows 'finished' status
                if (
                    !['finished', 'approved', 'closed'].includes(
                        workOrder.status
                    )
                ) {
                    return undefined
                }

                // Filter by readAllWO permission in code (not in query)
                const createdById = this.woMethods.createdById(
                    workOrder.createdBy
                )
                if (
                    !this.user?.permissions?.includes('readAllWO') &&
                    createdById != this.user.id
                ) {
                    return undefined
                }

                this.woMethods.assignCreatedBy(workOrder, this.users)

                // get or fetch project
                workOrder.project = this.projects[workOrder.projectId] || {}
                if (
                    !workOrder.project ||
                    Object.keys(workOrder.project).length == 0
                ) {
                    workOrder.project = await API.getProject(
                        workOrder.projectId
                    )
                    // add project to projects object
                    this.projects[workOrder.projectId] = workOrder.project
                }

                // Format items
                const formattedWO = this.woMethods.formatItems(workOrder)
                return formattedWO || workOrder
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
                return undefined
            }
        },
        async closeWO() {
            try {
                this.loading = true
                await API.closeWorkOrder({
                    workOrderId: this.selectedOrder.id,
                    notificationId: 'ar0vX28u4hadZW2pVn9n',
                })
                this.workOrders = this.workOrders.filter(
                    order => order.id != this.selectedOrder.id
                )
                this.closeProductionClosing()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        closeProductionClosing() {
            this.selectedOrder = {}
            this.productionClosing = false
        },
        openProductionClosing(workOrder) {
            this.selectedOrder = _.cloneDeep(workOrder)
            this.productionClosing = true
        },
        openProcessWorkOrder(item) {
            this.openProcessWorkOrderAsync(item)
        },
        async openProcessWorkOrderAsync(item) {
            try {
                this.loading = true
                let order = await this.woMethods.hydrateWorkOrderOnOpen(
                    this.companyId,
                    item
                )
                order = _.cloneDeep(order)
                order = (await this.formatWorkOrder(order)) || order
                this.attachListMetrics(order)
                this.selectedOrder = _.cloneDeep(order)
                this.processWorkOrder = true
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        closeProcessWorkOrder() {
            this.processWorkOrder = false
        },
        filterOrder(order) {
            return order.code
                .toLowerCase()
                .includes(this.searchDebounced.toLowerCase())
        },
        filterProject(order) {
            return (
                order.project.name
                    .toLowerCase()
                    .includes(this.projectToFilterDebounced.toLowerCase()) ||
                order.project.reference
                    .toString()
                    .toLowerCase()
                    .includes(this.projectToFilterDebounced.toLowerCase())
            )
        },
        filterByType(order) {
            const type = order.assemblyWorkOrder ? 'assembly' : 'production'
            return type.includes(this.typeToFilterDebounced.toLowerCase())
        },
        formatDate(seconds) {
            return `${moment.unix(seconds).format('L')} ${moment
                .unix(seconds)
                .format('LT')}`
        },
        sort() {
            this.workOrders.sort(
                (a, b) =>
                    (b.createdOn.seconds || b.createdOn._seconds) -
                    (a.createdOn.seconds || a.createdOn._seconds)
            )
        },
        openResource() {
            if (this.resourceId) {
                const resource = this.workOrders.find(
                    w => w.id == this.resourceId
                )
                if (resource) {
                    this.resourceId = undefined
                    this.openProcessWorkOrder(resource)
                }
            }
        },
        attachListMetrics(wo) {
            if (!wo) {
                return wo
            }
            if (!wo.formatted) {
                this.woMethods.formatItems(wo)
            }
            wo.qualitySummary = {
                pending: this.calculateWOPending(wo) || 0,
                released: this.calculateWOReleased(wo) || 0,
                reprocess: this.calculateWOReprocess(wo) || 0,
                rejected: this.calculateWORejected(wo) || 0,
            }
            wo.packingProgressText = this.packingProgress(wo)
            return wo
        },
        calculateWOPending(wo) {
            try {
                let totalPending = 0
                wo.items.forEach(item => {
                    let pendingQty = 0

                    let lastProcessIndex = item.processes.length - 1
                    if (wo.assemblyWorkOrder != undefined) {
                        lastProcessIndex =
                            item.processes.findIndex(
                                p => p == this.qualityProcess.id
                            ) - 1
                    }
                    if (lastProcessIndex > -1) {
                        const lastProductionProcess =
                            item.processes[lastProcessIndex]
                        if (item.production) {
                            const production = item.production.filter(
                                entry =>
                                    entry.process.id == lastProductionProcess
                            )
                            if (production.length > 0) {
                                pendingQty = production.reduce(
                                    (accumulator, entry) =>
                                        accumulator + entry.qty,
                                    0
                                )
                            }
                        }
                        if (item.quality) {
                            const rejected = item.quality.reduce(
                                (accumulator, entry) =>
                                    accumulator + (entry.rejectQty || 0),
                                0
                            )
                            const released = item.quality.reduce(
                                (accumulator, entry) =>
                                    accumulator + (entry.releaseQty || 0),
                                0
                            )
                            pendingQty -=
                                Number(released || 0) + Number(rejected || 0)
                        }
                    }
                    totalPending += pendingQty
                })

                return totalPending
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        calculateWOReleased(wo) {
            try {
                let totalReleased = 0
                wo.items.forEach(item => {
                    let released = 0
                    if (item.quality) {
                        const value = item.quality.reduce(
                            (accumulator, entry) =>
                                accumulator + (entry.releaseQty || 0),
                            0
                        )
                        released += Number(value || 0)
                    }
                    totalReleased += released
                })
                return totalReleased
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        calculateWOReprocess(wo) {
            try {
                let totalReprocess = 0
                wo.items.forEach(item => {
                    let reprocess = 0
                    if (item.quality) {
                        const value = item.quality.reduce(
                            (accumulator, entry) =>
                                accumulator + (entry.reprocessQty || 0),
                            0
                        )
                        reprocess += Number(value || 0)
                    }
                    totalReprocess += reprocess
                })

                return totalReprocess
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        calculateWORejected(wo) {
            try {
                let totalRejected = 0
                wo.items.forEach(item => {
                    let rejected = 0
                    if (item.quality) {
                        const value = item.quality.reduce(
                            (accumulator, entry) =>
                                accumulator + (entry.rejectQty || 0),
                            0
                        )
                        rejected += Number(value || 0)
                    }
                    totalRejected += rejected
                })

                return totalRejected
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        packingProgress(workOrder) {
            let total = 0
            let packed = 0

            if (workOrder.items) {
                workOrder.items.forEach(item => {
                    if (item.processes?.includes(this.packingProcess.id)) {
                        total += +item.quantity
                        packed += +item.packedQty || 0
                    }
                })
            }

            const percentage = total > 0 ? (packed / total) * 100 : 100
            return `${packed}/${total} ${percentage.toFixed(2)}%`
        },
        setProcessesInfo(wo) {
            wo.processesInfo = []
            let qualityProcess = {
                process: {
                    id: this.qualityProcess.id,
                    name: this.qualityProcess.name,
                },
                qty: 0,
                received: 0,
                delivered: 0,
                produced: 0,
                available: 0,
            }

            let packingProcess = {
                process: {
                    id: this.packingProcess.id,
                    name: this.packingProcess.name,
                },
                qty: 0,
                received: 0,
                delivered: 0,
                produced: 0,
                available: 0,
            }

            const items = wo.items || []
            items.forEach(item => {
                if (item.processes) {
                    item.processes.forEach(process => {
                        let processInfo = wo.processesInfo.find(
                            info => info.process.id == process
                        )

                        if (!processInfo) {
                            let totalDelivered = item.deliveries
                                ? item.deliveries.reduce(
                                      (total, register) =>
                                          register.prevProcess.id == process
                                              ? total + register.qty
                                              : total,
                                      0
                                  )
                                : 0
                            let totalProduced = item.production
                                ? item.production.reduce(
                                      (total, register) =>
                                          register.process.id == process
                                              ? total + register.qty
                                              : total,
                                      0
                                  )
                                : 0

                            let received = item.deliveries
                                ? item.deliveries.filter(
                                      register =>
                                          register.nextProcess.id == process &&
                                          register.receivedBy
                                  )
                                : []
                            let totalReceived = received.reduce(
                                (total, register) => total + register.qty,
                                0
                            )
                            let processIndex = this.settingProcesses.processes.findIndex(
                                p => p.id == process
                            )

                            const pIndex = item.processes.findIndex(
                                p => p == process
                            )
                            if (pIndex == 0) {
                                totalReceived = item.quantity
                            }

                            if (
                                this.settingProcesses.processes[processIndex] !=
                                undefined
                            ) {
                                wo.processesInfo.push({
                                    process: {
                                        id: this.settingProcesses.processes[
                                            processIndex
                                        ].id,
                                        name: this.settingProcesses.processes[
                                            processIndex
                                        ].name,
                                    },
                                    qty: item.quantity,
                                    delivered: totalDelivered,
                                    produced: totalProduced,
                                    received: totalReceived,
                                    available: totalReceived - totalProduced,
                                })
                            }
                        } else {
                            processInfo.qty += item.quantity
                            processInfo.delivered += item.deliveries
                                ? item.deliveries.reduce(
                                      (total, register) =>
                                          register.prevProcess.id == process
                                              ? total + register.qty
                                              : total,
                                      0
                                  )
                                : 0
                            processInfo.produced += item.production
                                ? item.production.reduce(
                                      (total, register) =>
                                          register.process.id == process
                                              ? total + register.qty
                                              : total,
                                      0
                                  )
                                : 0

                            const receivedEntries = item.deliveries
                                ? item.deliveries.filter(
                                      e => e.nextProcess == process
                                  )
                                : []

                            processInfo.received += receivedEntries.reduce(
                                (total, register) => total + register.qty,
                                0
                            )
                        }
                    })

                    //packing process
                    let totalReceivedNew = item.deliveries
                        ? item.deliveries.reduce(
                              (total, register) =>
                                  register.nextProcess.id ==
                                      this.packingProcess.id &&
                                  register.receivedBy
                                      ? total + register.qty
                                      : total,
                              0
                          )
                        : 0

                    let totalReceivedOld = item.deliveries
                        ? item.deliveries.reduce(
                              (total, register) =>
                                  register.nextProcess.id ==
                                      this.readyForPackingProcess?.id &&
                                  register.receivedBy
                                      ? total + register.qty
                                      : total,
                              0
                          )
                        : 0

                    let totalReceived = totalReceivedOld + totalReceivedNew

                    if (item.processes.includes(this.packingProcess.id)) {
                        packingProcess.qty += item.quantity
                        packingProcess.delivered = 'NA'
                        packingProcess.produced += item.packedQty
                        packingProcess.available =
                            totalReceived - (packingProcess.produced || 0)
                    }

                    // quality process
                    if (item.processes.includes(this.qualityProcess.id)) {
                        qualityProcess.qty += item.quantity
                        qualityProcess.delivered = 'NA'
                        qualityProcess.produced =
                            this.calculateRejectedQty(item) +
                            this.calculateReleasedQty(item)
                        qualityProcess.available = this.calculateQualityPending(
                            item,
                            wo
                        )
                    }
                }
            })
            if (qualityProcess.qty > 0) {
                wo.processesInfo.push(qualityProcess)
            }
            if (packingProcess.qty > 0) {
                wo.processesInfo.push(packingProcess)
            }
            if (this.selectedOrder && this.selectedOrder.id == wo.id) {
                this.selectedOrder = _.cloneDeep(wo)
            }
        },
        calculateQualityPending(item, workOrder) {
            try {
                let pendingQty = 0
                let lastProcessIndex = item.processes.length - 1
                if (workOrder.assemblyWorkOrder != undefined) {
                    lastProcessIndex =
                        item.processes.findIndex(
                            p => p == this.qualityProcess.id
                        ) - 1
                }
                if (lastProcessIndex > -1) {
                    const lastProductionProcess =
                        item.processes[lastProcessIndex]
                    if (item.production) {
                        const production = item.production.filter(
                            entry => entry.process.id == lastProductionProcess
                        )
                        if (production.length > 0) {
                            pendingQty = production.reduce(
                                (accumulator, entry) => accumulator + entry.qty,
                                0
                            )
                        }
                    }
                    if (item.quality) {
                        const rejected = item.quality.reduce(
                            (accumulator, entry) =>
                                accumulator + (entry.rejectQty || 0),
                            0
                        )
                        const released = item.quality.reduce(
                            (accumulator, entry) =>
                                accumulator + (entry.releaseQty || 0),
                            0
                        )
                        pendingQty -=
                            Number(released || 0) + Number(rejected || 0)
                    }
                }
                return pendingQty
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        calculateReleasedQty(item) {
            try {
                let released = 0
                if (item.quality) {
                    const value = item.quality.reduce(
                        (accumulator, entry) =>
                            accumulator + (entry.releaseQty || 0),
                        0
                    )
                    released += Number(value || 0)
                }
                return released
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        calculateRejectedQty(item) {
            try {
                let rejected = 0
                if (item.quality) {
                    const value = item.quality.reduce(
                        (accumulator, entry) =>
                            accumulator + (entry.rejectQty || 0),
                        0
                    )
                    rejected += Number(value || 0)
                }
                return rejected
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
    },
}
</script>

<style>
.v-input .v-label {
    font-size: 12px;
}
</style>
